import _regeneratorRuntime from 'babel-runtime/regenerator';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import filter from '@com/image/filter';

var basicStyle = {
  hue: 0,
  saturation: 0,
  luminance: 0,
  blur: 0
};

export default {
  props: {
    urls: {
      required: true,
      type: Array
    },
    filters: {
      required: true,
      type: Object
    },
    // 是开启 filter，默认打开。如果 false 的话，则只处理数据，不处理图片
    enableFilter: {
      required: false,
      type: Boolean,
      default: true
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideReset: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      basicStyle: basicStyle
    };
  },


  computed: {
    title: function title() {
      return this.$t('basic.imageFilter.title');
    },
    basicStyleFormItemList: function basicStyleFormItemList() {
      var _this = this;

      return [{
        schema: {
          prop: 'hue',
          component: 'slider',
          field: {
            min: 0,
            max: 360,
            listeners: {
              change: function change(value) {
                _this.filter({ prop: 'hue', value: value });
              }
            }
          },
          label: this.$t('basic.imageFilter.tone')
        },
        input: {
          min: 0,
          max: 360,
          controls: false
        }
      }, {
        schema: {
          prop: 'saturation',
          component: 'slider',
          field: {
            min: -2,
            max: 10,
            step: 0.1,
            listeners: {
              change: function change(value) {
                _this.filter({ prop: 'saturation', value: value });
              }
            }
          },
          label: this.$t('basic.imageFilter.saturation')
        },
        input: {
          min: -2,
          max: 10,
          controls: false
        }
      }, {
        schema: {
          prop: 'luminance',
          component: 'slider',
          field: {
            min: -2,
            max: 2,
            step: 0.1,
            listeners: {
              change: function change(value) {
                _this.filter({ prop: 'luminance', value: value });
              }
            }
          },
          label: this.$t('basic.imageFilter.brightness')
        },
        input: {
          min: -2,
          max: 2,
          controls: false
        }
      }, {
        schema: {
          prop: 'blur',
          component: 'slider',
          field: {
            min: 0,
            max: 40,
            listeners: {
              change: function change(value) {
                _this.filter({ prop: 'blurRadius', value: value });
              }
            }
          },
          label: this.$t('basic.imageFilter.ambiguity')
        },
        input: {
          min: 0,
          max: 40,
          controls: false
        }
      }];
    }
  },
  mounted: function mounted() {
    this.basicStyle = _extends({}, basicStyle, this.filters);
  },

  watch: {
    filters: {
      handler: function handler(value, oldValue) {
        if (value !== oldValue) {
          this.basicStyle = _extends({}, basicStyle, this.filters);
        }
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    filter: function filter(_ref) {
      var prop = _ref.prop,
          value = _ref.value;

      this.update(prop, value);
    },
    inputChange: function inputChange(prop) {
      this.update(prop, Number(this.basicStyle[prop]));
    },
    reset: function reset() {
      this.basicStyle = _extends({}, this.filters, basicStyle);
      this.update();
    },
    update: function update(prop, value) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var urls;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (prop && !_.isUndefined(value)) {
                  _this2.basicStyle = _extends({}, _this2.basicStyle, _defineProperty({}, prop, value));
                }
                _this2.$emit('change', { filters: _this2.basicStyle });

                if (!_this2.enableFilter) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return filter({
                  urls: _this2.urls,
                  filters: _extends({}, _.omit(_this2.basicStyle, ['blur']), {
                    blurRadius: _this2.basicStyle.blur
                  })
                });

              case 5:
                urls = _context.sent;

                urls && _this2.$emit('on-success', { urls: urls, filters: _this2.basicStyle });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
};